import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormSection, TextField, SelectField, TextAreaField, FileUploadField, DisplayField } from '../components/FormComponents';
import { StatusBadge } from '../components/StatusBadge';
import { mockSuppliers } from '../data/mockData';
export function SupplierForm({
  mode = 'create'
}: {
  mode?: 'create' | 'edit' | 'signup';
}) {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // In a real app, fetch data based on ID. Using mock for now.
  const initialData = mode === 'edit' && id ? mockSuppliers.find(s => s.id === id) : null;
  const [formData, setFormData] = useState<any>(initialData || {
    code: 'AUTO-GEN',
    name: '',
    type: '',
    category: '',
    businessType: '',
    countryOfOrigin: '',
    businessOperationCountry: '',
    localInternational: '',
    website: '',
    communicationAddress: '',
    contactPersonName: '',
    phone: '',
    mobile: '',
    email: '',
    authorizedPersonName: '',
    designation: '',
    authorizedEmail: '',
    authorizedPhone: '',
    bankName: '',
    branchName: '',
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    swiftCode: '',
    status: 'Active'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock save
    alert('Supplier saved successfully!');
    if (mode === 'signup') navigate('/');else navigate('/suppliers');
  };
  const isSignUp = mode === 'signup';
  return <div className={`space-y-6 ${isSignUp ? 'max-w-4xl mx-auto py-8' : ''}`} data-id="element-2793">
      {!isSignUp && <div className="flex items-center justify-between" data-id="element-2794">
          <div data-id="element-2795">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-2796">
              {mode === 'create' ? 'Create Supplier' : 'Update Supplier'}
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2797">
              Fill in the supplier details below.
            </p>
          </div>
        </div>}

      {isSignUp && <div className="text-center mb-8" data-id="element-2798">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-2799">
            Supplier Registration
          </h1>
          <p className="text-gray-500 mt-2" data-id="element-2800">Join our procurement network</p>
        </div>}

      <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-2801">
        <FormSection title="General Information" data-id="element-2802">
          {mode !== 'create' && !isSignUp ? <DisplayField label="Supplier Code" value={formData.code} data-id="element-2803" /> : <TextField label="Supplier Code" name="code" value={formData.code} disabled required data-id="element-2804" />}
          <TextField label="Supplier Name" name="name" value={formData.name} onChange={handleChange} required data-id="element-2805" />

          <SelectField label="Supplier Type" name="type" value={formData.type} onChange={handleChange} required options={[{
          value: 'Firm',
          label: 'Firm'
        }, {
          value: 'Individual',
          label: 'Individual'
        }]} data-id="element-2806" />

          <SelectField label="Category" name="category" value={formData.category} onChange={handleChange} required options={[{
          value: 'Service',
          label: 'Service'
        }, {
          value: 'Goods',
          label: 'Goods'
        }, {
          value: 'Works',
          label: 'Works'
        }, {
          value: 'Others',
          label: 'Others'
        }]} data-id="element-2807" />

          <SelectField label="Business Type" name="businessType" value={formData.businessType} onChange={handleChange} required options={[{
          value: 'Limited',
          label: 'Limited'
        }, {
          value: 'Sole Proprietorship',
          label: 'Sole Proprietorship'
        }, {
          value: 'Consultant',
          label: 'Consultant'
        }, {
          value: 'Other',
          label: 'Other'
        }]} data-id="element-2808" />

          <TextField label="Country of Origin" name="countryOfOrigin" value={formData.countryOfOrigin} onChange={handleChange} required data-id="element-2809" />
          <TextField label="Business Operation Country" name="businessOperationCountry" value={formData.businessOperationCountry} onChange={handleChange} required data-id="element-2810" />

          <SelectField label="Local / International" name="localInternational" value={formData.localInternational} onChange={handleChange} options={[{
          value: 'Local',
          label: 'Local'
        }, {
          value: 'International',
          label: 'International'
        }]} data-id="element-2811" />

          <TextField label="Website" name="website" type="url" value={formData.website} onChange={handleChange} data-id="element-2812" />
          <TextAreaField label="Communication Address" name="communicationAddress" value={formData.communicationAddress} onChange={handleChange} required rows={3} data-id="element-2813" />
        </FormSection>

        <FormSection title="Contact Details" data-id="element-2814">
          <TextField label="Contact Person Name" name="contactPersonName" value={formData.contactPersonName} onChange={handleChange} required data-id="element-2815" />
          <TextField label="Phone" name="phone" value={formData.phone} onChange={handleChange} data-id="element-2816" />
          <TextField label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} required data-id="element-2817" />
          <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required data-id="element-2818" />
        </FormSection>

        <FormSection title="Authorized Person" data-id="element-2819">
          <TextField label="Authorized Person Name" name="authorizedPersonName" value={formData.authorizedPersonName} onChange={handleChange} required data-id="element-2820" />
          <TextField label="Designation" name="designation" value={formData.designation} onChange={handleChange} data-id="element-2821" />
          <TextField label="Authorized Email" name="authorizedEmail" type="email" value={formData.authorizedEmail} onChange={handleChange} required data-id="element-2822" />
          <TextField label="Authorized Phone/Mobile" name="authorizedPhone" value={formData.authorizedPhone} onChange={handleChange} required data-id="element-2823" />
        </FormSection>

        <FormSection title="Bank Details" data-id="element-2824">
          <TextField label="Bank Name" name="bankName" value={formData.bankName} onChange={handleChange} required data-id="element-2825" />
          <TextField label="Branch Name" name="branchName" value={formData.branchName} onChange={handleChange} required data-id="element-2826" />
          <TextField label="Account Name" name="accountName" value={formData.accountName} onChange={handleChange} required data-id="element-2827" />
          <TextField label="Account Number" name="accountNumber" value={formData.accountNumber} onChange={handleChange} required data-id="element-2828" />
          <TextField label="Routing Number" name="routingNumber" value={formData.routingNumber} onChange={handleChange} required data-id="element-2829" />
          <TextField label="SWIFT Code" name="swiftCode" value={formData.swiftCode} onChange={handleChange} required data-id="element-2830" />
        </FormSection>

        <FormSection title="Legal Documents" data-id="element-2831">
          <FileUploadField label="Upload Documents (PDF/Image)" data-id="element-2832" />
        </FormSection>

        <FormSection title="Contract Information" data-id="element-2833">
          <TextField label="Contract Expiry Date" name="contractExpiry" type="date" value={formData.contractExpiry || ''} onChange={handleChange} required data-id="element-2834" />
          <FileUploadField label="Upload Contract Document (PDF)" data-id="element-2835" />
          {formData.contractExpiry && new Date(formData.contractExpiry) < new Date() && <div className="md:col-span-2 bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-700 flex items-center" data-id="element-2836">
                <span className="font-medium mr-1" data-id="element-2837">⚠ Contract Expired:</span>
                This supplier's contract expired on {formData.contractExpiry}.
                Please renew the contract.
              </div>}
        </FormSection>

        {mode === 'edit' && !isSignUp && initialData && <FormSection title="Performance & Status" data-id="element-2838">
            <DisplayField label="KPI Score" value={<span className="text-lg font-semibold" data-id="element-2840">
                  {initialData.kpiScore}
                </span>} data-id="element-2839" />
            <DisplayField label="Rating Percentage" value={<span className="text-lg font-semibold" data-id="element-2842">
                  {initialData.ratingPercentage}%
                </span>} data-id="element-2841" />
            <DisplayField label="Performance Status" value={<StatusBadge status={initialData.performanceStatus} data-id="element-2844" />} data-id="element-2843" />

            <SelectField label="Status" name="status" value={formData.status} onChange={handleChange} required options={[{
          value: 'Active',
          label: 'Active'
        }, {
          value: 'Inactive',
          label: 'Inactive'
        }, {
          value: 'Blacklisted',
          label: 'Blacklisted'
        }, {
          value: 'Expired',
          label: 'Expired'
        }]} data-id="element-2845" />
          </FormSection>}

        {isSignUp && <FormSection title="Account Security" data-id="element-2846">
            <TextField label="Password" name="password" type="password" required data-id="element-2847" />
            <TextField label="Confirm Password" name="confirmPassword" type="password" required data-id="element-2848" />
            <div className="md:col-span-2 flex items-center mt-4" data-id="element-2849">
              <input type="checkbox" id="terms" required className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-2850" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-900" data-id="element-2851">
                I accept the Terms & Conditions and Privacy Policy
              </label>
            </div>
          </FormSection>}

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end space-x-3" data-id="element-2852">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-2853">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2854">
            {isSignUp ? 'Sign Up' : 'Save Supplier'}
          </button>
        </div>
      </form>
    </div>;
}